import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import Student from '../Layouts/StudentForm';
import { useGetStudentByIdQuery, useUpdateStudentByIdMutation } from 'src/services/StudentService';
import { showToast } from 'src/utils/showToaster';
import { CircularProgress } from '@mui/material';
import { StudentFormValues } from 'src/models/Student.mode';

type Props = {
  onClose: () => void;
  selectedStudentId: string;
};

const EditStudentWrapper = ({ onClose, selectedStudentId }: Props) => {
 
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetStudentByIdQuery(selectedStudentId);
  const [updateFacultyById] = useUpdateStudentByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);


  const initialValues: StudentFormValues = {
    name: items?.name || '',
    mobile: items?.mobile || '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required('Please enter Student name'),
    mobile: string().required('Please enter Student mobile').min(10).max(10),
  });

  // Handle Submit
  const handleSubmit = (
    values: StudentFormValues,
    { setSubmitting, resetForm }: FormikHelpers<StudentFormValues>
  ) => {
   
    updateFacultyById({ id: selectedStudentId, body: values }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };
  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Student formikProps={formikProps} onClose={onClose} formType="EDIT" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditStudentWrapper;